module.exports = __webpack_public_path__ + "static/meet-concierge-desktop-ce598811008a18e989bb8cbd97209f86.webp";